import React, { useCallback } from 'react'
import { GtmHelper, findApiV4Link, gaEvent } from 'shared'
import classNames from 'classnames'
import { DonateButtonProps } from './types'

export const DonateButton = ({
  project,
  gaAction,
  className,
  activeMatchingFund,
  status,
}: DonateButtonProps): JSX.Element | null => {
  const donateUrl = (project && project.links && findApiV4Link({ ofObject: project, withRel: 'new_donation' })) || ''

  const tracking = useCallback(() => {
    // TODO check if pushing "default values" aka null project is perhaps intended and the following guard is invalid
    if (!project.id) return
    GtmHelper.pushAddToBasket(project)
    gaEvent('donation', gaAction)
  }, [project, gaAction])

  if (status === 'blocked')
    return (
      <div className="generic-placeholder-box is-secondary">
        {I18n.t('projects.show.stats.donate_button_blocked_explanation')}
      </div>
    )

  if (status === 'preparing')
    return <div className="generic-placeholder-box">{I18n.t('projects.show.stats.donate_button_placeholder')}</div>

  if (status === 'closed' || project.progress_percentage >= 100) return null

  return (
    <a
      className={classNames('btn', 'btn-primary', className, {
        'duplication-icon matching-fund': activeMatchingFund,
      })}
      href={donateUrl}
      onClick={tracking}
    >
      {I18n.t('projects.show.stats.donate_button_label')}
    </a>
  )
}
